import { TWasmId } from "~/interfaces";
import Wasm from "../wasm";
import { IWasmStoreGeometry } from "../store/interfaces";

export default class WasmMapGeometry {
	_wasmIds: Array<TWasmId>;

	_wasm: Wasm;

	_data: IWasmStoreGeometry;

	_customData: any;

	constructor(wasm: Wasm, data: IWasmStoreGeometry) {
		this._wasmIds = [];
		this._wasm = wasm;
		this._data = structuredClone(data);
		this._customData = {
			...data.customData,
		};

		this._build();
	}

	destroy() {
		const { mapContent } = this._wasm.exports;

		for (const wasmId of this._wasmIds) {
			mapContent.remove(wasmId);
		}
	}

	get wasmIds() {
		return this._wasmIds;
	}

	updatePoints(points: IWasmStoreGeometry["points"]) {
		const { mapContent, module } = this._wasm.exports;

		for (const wasmId of this._wasmIds) {
			mapContent.updateLineData(wasmId, {
				coordType: module.CoordSystem.Wgs,
				data: points,
			});
		}
	}

	_build() {
		const { mapContent, module, lineStyles } = this._wasm.exports;

		let style: Module.LineStyle = lineStyles.blue;

		switch (this._data.type) {
			case "blue":
				style = lineStyles.blue;
				break;

			case "red":
				style = lineStyles.red;
				break;

			case "green":
				style = lineStyles.green;
				break;

			case "route":
				style = lineStyles.route;
				break;

			default:
		}

		this._wasmIds.push(mapContent.addLine(this._data.points, module.ObjectLayer.OverAll, 0, style, module.RequestedCallbacks.OnClickAndHover, this._customData));
		//this._wasmIds.push(mapContent.addLine(this._data.points, module.ObjectLayer.OverAll, 0, lineStyles.routeWalkBg, module.RequestedCallbacks.OnClickAndHover, this._customData));
	}
}
